export const initialNumericData = {
    longUIquestion : "",
    type: "range",
    question: "",
    questionid:"",
    min:0,
    max:0,
    inc:0,
    default_value:0,
    anchors:[],
    schedule:{
        1:[],
        2:[],
        3:[],
        4:[],
        5:[],
        6:[],
        7:[]
    }
}


export const initialDiscreteData = {
    longUIquestion: "",
    question: "",
    questionid:0,
    type:"discrete",
    values:[],
    schedule:{
        1:[],
        2:[],
        3:[],
        4:[],
        5:[],
        6:[],
        7:[]
    }
}

export const initialCognitiveData = {
    numberOfDigits: 0,
    questionid: 0,
    testOrder: "",
    testType: "",
    schedule: {
        1:[],
        2:[],
        3:[],
        4:[],
        5:[],
        6:[],
        7:[]
    }
}

export const initialConfigureWatchParameters = {
    accel_active: false,
    accel_rate:0,
    battery_active:false,
    battery_rate:0,
    export_rate:0,
    gyro_active:false,
    heartrate_active:false,
    heartrate_rate:0,
    location_active:false,
    location_rate:0,
    pressure_active:false,
    SAMPLING_RATE:0
}

